import { HEIGHT, WIDTH } from '~/lib/stage'

export const videoFit = (sourceWidth, sourceHeight, stageWidth = WIDTH, stageHeight = HEIGHT) => {
	const sw = Number(sourceWidth)
	const sh = Number(sourceHeight)
	const valid = Number.isFinite(sw) && Number.isFinite(sh) && sw > 0 && sh > 0

	// Cover: match the axis that would otherwise leave a gap, and overflow the other.
	const sourceAspect = valid ? sw / sh : stageWidth / stageHeight
	const stageAspect = stageWidth / stageHeight

	const width = sourceAspect > stageAspect ? stageHeight * sourceAspect : stageWidth
	const height = sourceAspect > stageAspect ? stageHeight : stageWidth / sourceAspect

	// Rounded to the precision a writer would store, or `settleValue` could never match the initial and the key would never prune. `x`/`y` name the pivot — the centre — so a cover fit sits on the stage's centre.
	return {
		x: Math.round(stageWidth / 2),
		y: Math.round(stageHeight / 2),
		width: Math.round(width),
		height: Math.round(height),
	}
}

/** Every source path publishes here; read only by the `originToPivot` migration. */
export const setVideoSource = (width, height) => {
	globalThis.vwidth = width || undefined
	globalThis.vheight = height || undefined
}

export const currentVideoFit = () => videoFit(globalThis.vwidth, globalThis.vheight)

export default videoFit
